export const LOGIN = 'LOGIN'

export const login = (data) => ({
  type: LOGIN,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'login',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: serialize(data)
    }
  }
})

function serialize(data) {
  if (!data) return;

  var s = [];

  for (var key in data) {
    s.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
  }

  return s.join('&')
}

export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'

export const setAuthToken = (payload) => ({
  type: SET_AUTH_TOKEN,
  payload
})

export const SET_AUTH_ERROR = 'SET_AUTH_ERROR'

export const setAuthError = (error) => ({
  type: SET_AUTH_ERROR,
  error
})

export const SET_AUTH_ERROR_MESSAGE = 'SET_AUTH_ERROR_MESSGAE'

export const setAuthErrorMessage = (message) => ({
  type: SET_AUTH_ERROR_MESSAGE,
  message
})

export const REFRESH_AUTH_TOKEN = 'REFRESH_AUTH_TOKEN'
export const refreshToken = (data) => ({
  type: REFRESH_AUTH_TOKEN,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'login',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: serialize(data)
    }
  }
})

export const SET_REFRESHING_TOKEN = 'SET_REFRESHING_TOKEN'
export const setRefreshingToken = (token_refreshing) => ({
  type: SET_REFRESHING_TOKEN,
  token_refreshing
})

export const SIGNUP = 'SIGNUP'
export const signup = (data) => ({
  type: SIGNUP,
  payload: {
    request: {
      mode: 'no-cors',
      url: 'signup',
      method: 'POST',
      data: { request: data }
    }
  }
})

export const RESET_SIGNUP_ERRORS = 'RESET_SIGNUP_ERRORS'
export const resetSignupErrors = (token_refreshing) => ({
  type: RESET_SIGNUP_ERRORS,
  token_refreshing
})



// WEBPACK FOOTER //
// ./src/redux/actions/authActions.js